@if (isLoading) {

  <sd-skeleton
    [appearance]="skeletonAppearanceEnum.heading"
    [count]="size === sizesEnum.s ? 0 : size === sizesEnum.m ? 2 : 4"
  />

} @else if (heading) {

  @let brandLogo = heading.brandLogo;
  @let logoClass = (brandLogo && brandLogo.size !== iconSizeEnum.default) ? 'is-' + brandLogo.size : '';

  @if (brandLogo?.media && brandLogo.position === PositionEnum.top) {
    <sd-banner
      class="c__brand-logo {{logoClass}}"
      [media]="brandLogo.media"
      [isFit]="true"
    />
  }

  @if (heading.title) {
    <sd-title
      [titleLevel]="titleLevel"
      [titleThemesConfig]="parentsThemesConfig ? null : titleThemesConfig"
      [customClass]="customClassTitle"
      [isDescription]="isDescription"
      class="c__main-title {{isInteractive ? 'is-interactive' : ''}}"
    >
      <sd-html [html]="heading.title" tag="span" />
    </sd-title>
  }

  @if (heading.subtitle) {
    <sd-title
      [titleLevel]="subtitleLevel ?? titleLevel + 1"
      [titleThemesConfig]="parentsThemesConfig ? null : titleThemesConfig"
      [customClass]="customClassSubtitle"
      [isDescription]="isDescription"
      class="c__subtitle"
    >
      <sd-html [html]="heading.subtitle" tag="span" />
    </sd-title>
  }

  @if (brandLogo?.media && brandLogo.position !== PositionEnum.top) {
    <sd-banner
      class="c__brand-logo {{logoClass}}"
      [media]="brandLogo.media"
      [isFit]="true"
    />
  }

  @if (isUnderlined) {
    <span class="c__underline"></span>
  }

  @if (heading.media && !isUnderlined) {
    <sd-banner
      class="{{heading.mediaSize ? 'is-media-size-' + heading.mediaSize : 'is-media-size-l'}}"
      [isFit]="true"
      [media]="heading.media"
    />
  }

  @if (heading.description) {
    @if ((!readMore || (heading.description.length <= limit))) {
      <sd-html
        class="c__description is-wysiwyg {{customClassDescription}}"
        [attr.aria-live]="isA11y ? 'polite' : ''"
        [attr.aria-atomic]="isA11y ? 'true' : ''"
        [html]="getHTMLText(heading.description)"
        tag="div"
      />
    } @else {
      <div sdIsCollapsible
        [limit]="limit"
        [collapsiblePanel]="hide"
        [previewPanel]="text"
        [cleanCode]="false"
        (isOpenChange)="toggleCollapse($event)"
        [action]="action"
        class="c__description {{isOpen ? 'is-open' : 'is-close'}}"
      >
        <p [attr.aria-hidden]="!isOpen">
          <span #text>
            <sd-html
              innerClass="is-inline is-wysiwyg {{customClassDescription}}"
              [html]="heading.description"
              tag="span"
            />
          </span>
          <span #hide>
            <sd-html
              innerClass="is-inline is-wysiwyg {{customClassDescription}}"
              [attr.aria-expanded]="isOpen"
              [html]="heading.description"
              [id]="idReadMore"
              tag="span"
            />
          </span>
        </p>
        <button #action type="button" class="is-toggle is-link d-flex" [attr.aria-controls]="idReadMore">
          <span class="is-caption is-bold">
            {{ (!isOpen ? 'actions.readMore':'actions.showLess') | translate }}
          </span>
          @if (heading.title) {
            <span class="is-visually-hidden">{{' - ' + heading.title}}</span>
          }
          <sd-icon [name]="isOpen ? iconNameOpened : iconNameClosed" [size]="iconSize" />
        </button>
      </div>
    }
  }

}
